import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLanguageComponent } from './select-language/select-language.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateService } from '../services/custom-translate.service';

import { FlexLayoutModule } from '@angular/flex-layout';
import { IonicModule } from '@ionic/angular';
import { PermissionMessageComponent } from './permission-message/permission-message.component';

// import { MatExpansionModule } from '@angular/material/expansion';
import { ModelPopupComponent } from './model-popup/model-popup.component';
import { CustomCameraComponent } from './custom-camera/custom-camera.component';
import { ChatBoxComponent } from './chat-box/chat-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MediaUploadStatusModalComponent } from './media-upload-status-modal/media-upload-status-modal.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { DocumentUploadModalComponent } from './document-upload-modal/document-upload-modal.component';
import { VideoPreviewComponent } from './video-preview/video-preview.component';
@NgModule({
  declarations: [SelectLanguageComponent, ModelPopupComponent, PermissionMessageComponent,
    CustomCameraComponent,
    MediaUploadStatusModalComponent,
    VideoPreviewComponent,
    DocumentUploadModalComponent,
    ImagePreviewComponent,
    ChatBoxComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    IonicModule.forRoot(),
    // MatExpansionModule,
    // MatCardModule,
    // MatTooltipModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateService
      }, isolate: false, extend: true
    })
  ],
  exports: [PermissionMessageComponent,
    CustomCameraComponent,
    ChatBoxComponent
    // MatExpansionModule
  ]
})
export class SharedModule { }
